<ins-selection-box class="componentInDialog" [options]="zonesToDisplay" [(value)]="zoneID" [label]="label"
  [validatorCfg]="validatorCfg"  (isValid)="updateDialogValidity($event)"
(valueChange)="onZoneValueChanged($event)" [disabled]="disabled"></ins-selection-box>
@if (invisibleZone && showAlertIfNotVisible) {
  <div class="label normalStyle asWarning warningUnderBoxRight">Note: Selected zone is currently not visible</div>
}
